<div class="d-flex flex-stack">
  <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
    <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-1">
      จัดการข้อมูลส่วนตัว
    </h1>
    <span class="text-muted fs-7"> อัปเดตโปรไฟล์และข้อมูลการติดต่อ </span>
  </div>
  <div class="d-flex align-items-center gap-4">
    <!-- <button
      class="btn btn-sm btn-outline btn-gray-400 btn-active-light border border-gray-300 text-gray-800"
    >
      ยกเลิก
    </button> -->

    <button class="btn btn-sm btn-primary" data-testid="profile-save" (click)="updateProfile()">
      บันทึกการเปลี่ยนแปลง
    </button>
  </div>
</div>
<div class="separator my-4"></div>
<section class="col-12 pt-4" [formGroup]="form">
  <div class="row g-6 mb-8">
    <div class="d-flex flex-row gap-4 col-12">
      <div class="d-flex">
        <app-upload-image [imageValue]="form.value.image_url" formControlName="image"
          imgSizeCSS="w-80px h-80px"></app-upload-image>
      </div>
      <div class="d-flex flex-end">
        <button type="button" class="btn btn-sm btn-secondary fw-semibold fs-7 rounded" (click)="selectImage()">
          {{ "เปลี่ยนรูปภาพ" | translate }}
        </button>
      </div>
    </div>
    <div class="col-6">
      <app-input label="APP.FIRST_NAME" name="first_name" formControlName="first_name" placeholder="APP.FIRST_NAME"
        [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error?.first_name"></app-input>
    </div>
    <div class="col-6">
      <app-input label="APP.LAST_NAME" name="last_name" formControlName="last_name" placeholder="APP.LAST_NAME"
        [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error?.last_name"></app-input>
    </div>
    <div class="col-6 mt-3">
      <app-input label="APP.NICKNAME" name="nickname" formControlName="nickname" placeholder="APP.NICKNAME"
        [labelMode]="LabelMode.DEFAULT" [error]="error?.nickname"></app-input>
    </div>
    <div class="col-6 mt-3">
      <app-input label="APP.ACADEMY" name="academy" formControlName="academy" placeholder="APP.ACADEMY"
        [labelMode]="LabelMode.DEFAULT" [error]="error?.academy"></app-input>
    </div>
    <div class="col-6 mt-3">
      <app-datepicker label="APP.DOB" name="birthdate" formControlName="birthdate" placeholder="APP.DATE_FORMAT"
        [labelMode]="LabelMode.DEFAULT" [required]="true" [error]="error?.birthdate"></app-datepicker>
    </div>
    <div class="col-6 mt-3">
      <app-input label="APP.PHONE" name="phone" formControlName="phone" placeholder="APP.PHONE"
        [labelMode]="LabelMode.DEFAULT" type="text" mask="0XX-XXX-XXXX" [dropSpecialCharacters]="true" [required]="true"
        [error]="error?.phone"></app-input>
    </div>
  </div>
</section>

<div class="separator my-8"></div>

<section class="">
  <div class="d-flex flex-column" [ngClass]="!addressFormActive() ? 'mb-3' : 'mb-8'">
    <div class="page-title d-flex flex-column justify-content-center flex-wrap me-3">
      <h1 class="page-heading d-flex text-gray-900 fw-bold fs-3 flex-column justify-content-center mb-2">
        ข้อมูลที่อยู่
      </h1>
    </div>

    @if(addressFormActive()){

    <app-address-form [data]="selectedAddress()" (closeForm)="toggleAddressForm(false)"></app-address-form>
    }
    <section></section>
    <!-- <div class="d-flex align-items-center gap-4">
      <button class="btn btn-sm btn-light-primary">เพิ่ม</button>
    </div> -->
  </div>

  <div class="row g-6">
    @for (address of userAddress(); track $index) {
    <div class="col-sm-6 col-xl-4">
      <div class="card h-100 min-h-150px shadow-none">
        <div class="card-header flex-nowrap border-0 p-5 align-items-end">
          <div class="d-flex flex-row col-12">
            <div class="card-title m-0 col-8">
              <a class="fs-4 fw-bold text-gray-800 m-0 text-overflow-line-1">
                {{ address.name }}
              </a>
            </div>
            <div class="card-toolbard d-flex justify-content-end flex-row m-0 col-4">
              <button type="button" class="btn btn-sm btn-icon btn-icon-info btn-active-light-info h-30px w-30px"
                (click)="editAddress(address)">
                <app-keenicon name="pencil" class="fs-4 svg svg-icon"></app-keenicon>
              </button>
              <button type="button" class="btn btn-sm btn-icon btn-icon-danger btn-active-light-danger h-30px w-30px"
                (click)="deleteAddress(address)">
                <app-keenicon name="trash" class="fs-4 svg svg-icon"></app-keenicon>
              </button>
            </div>
          </div>
        </div>

        <div class="card-body d-flex flex-column">
          <div class="d-flex align-items-center flex-wrap fs-6">
            <!-- <i class="ki-duotone ki-Up-right fs-3 me-1 text-danger"></i> -->
            <!-- <div class="fw-bold text-danger me-2">+40.5%</div> -->

            <div class="fs-6 fw-normal text-gray-700 text-overflow-line-4">
              <span class="fw-semibold">{{ address.address }}</span>
              {{`ตำบล${address.sub_district!.name_th} อำเภอ${address.district!.name_th}
              จังหวัด${address.province!.name_th} ${address.sub_district!.post_code}`}}
            </div>
          </div>
        </div>
      </div>
    </div>

    } @if(!addressFormActive()){
    <div class="col-sm-6 col-xl-4">
      <button
        class="btn btn-outline btn-outline-gray-400 btn-outline-dashed btn-active-light-info border-hover-info border-active-info w-100 flex-shrink-0 p-6 h-100 min-h-150px"
        (click)="toggleAddressForm(true)">
        <app-keenicon name="plus" class="fs-1 svg svg-icon mb-4"></app-keenicon>
        <h6 class="fs-7 fw-normal mb-0">เพิ่มที่อยู่</h6>
      </button>
    </div>

    }
  </div>
</section>